export default "__VITE_ASSET__2fa594c2__"